import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

import { getDomains, checkDomain as checkDomainRequest, createDomain as createDomainRequest } from '../services/Domains';

// Fetches the account's domains and picks the current one: keep the current selection if still valid,
// otherwise use the cookie, then the account default, then the first domain.
export const fetchDomains = createAsyncThunk('domains/fetch', async (_, { getState }) => {
  const { domains = [], credits = 0 } = await getDomains();
  const { app, account } = getState();
  const good = domains.filter(domain => domain.status === 'good');
  const candidates = (good.length ? good : domains).map(domain => domain.domain);
  const preferred = [app.current_domain, Cookies.get('current_domain'), account.default_domain];
  const current_domain = preferred.find(name => candidates.includes(name)) || candidates[0] || '';
  return { domains, credits, current_domain };
});

const domainsSlice = createSlice({
  name: 'domains',
  initialState: { domains: [], credits: 0 },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchDomains.fulfilled, (state, { payload }) => {
      state.domains = payload.domains;
      state.credits = payload.credits;
    });
  },
});

export default domainsSlice.reducer;

export const selectGoodDomains = createSelector(
  state => state.domains.domains,
  domains => domains.filter(domain => domain.status === 'good')
);

export const checkDomain = (domain) => async (dispatch) => {
  await checkDomainRequest(domain);
  dispatch(fetchDomains());
};

export const createDomain = (domain) => async (dispatch) => {
  const result = await createDomainRequest(domain);
  dispatch(fetchDomains());
  return result;
};
